import './index.scss';

import SvgIcon from "../../atoms/svgicon";

class MenuItem {
    constructor(element) {
        this.element = element;
        this._clickHandler = null;
    }

    get hasChildren() {
        return this.element.getAttribute('data-has-children');
    }

    get menuUid() {
        return this.element.getAttribute('data-menu-uid');
    }

    set clickHandler(clickHandler) {
        this._clickHandler = clickHandler;
    }
}

class SubMenu {
    constructor(element) {
        this.element = element;
    }

    get menuLevel() {
        return this.element.getAttribute('data-level');
    }

    getMenuItemsHTML(uid) {
        if (this.element === null) {
            return Array.from(
                this.element.querySelectorAll('.menu-item[data-menu-level="' + this.menuLevel + '"][data-parent-menu-uid="' + uid + '"]'))
                .map(el => el.outerHTML)
                .join("\n");
        } else {
            return Array.from(
                this.element.querySelectorAll('.menu-item[data-menu-level="' + this.menuLevel + '"]'))
                .map(el => el.outerHTML)
                .join("\n");
        }
    }

    get uid() {
        return this.element.getAttribute('data-menu-uid');
    }

    get text() {
        return Array.from(this.element.children)
            .filter(el => el.tagName == "P")
            .map(el => el.innerHTML)
            .join("\n")
            .trim();
    }

    get parentMenuUid() {
        return this.element.getAttribute('data-parent-menu-uid');
    }

    get hasParentMenu() {
        return this.parentMenuUid !== "0";
    }

    getMenuTitleHTML() {
        if (this.element === null || this.element.querySelector('.title') === null) {
            return '';
        }
        return this.element.querySelector('.title').outerHTML;
    }

    renderMenu(uid) {
        return this.getMenuTitleHTML() + "\n" + this.getMenuItemsHTML(uid);
    }
}

class SlidingPanesMenu {
    openMenu(uid) {
        this.overlayContainer = window.app.siteHeader.openOverlay(this.closeMenu.bind(this), true);
        this.overlayContainer.innerHTML = `<div class="sliding-pane-menu-overlay" data-current-menu-level="0">
            <div class="panes">
                <div class="text-pane pane"></div>
                <div class="menupanes">
                    <div class="back-links">
                        <div class="back-link-mobile back-link" data-back-link-uid="0"><a href="javascript:void(0);">` + new SvgIcon().singleBackArrow() + ` Zurück</a></div>
                        <div class="back-link-parent back-link" data-back-link-uid="0"><a href="javascript:void(0);">` + new SvgIcon().singleBackArrow() + ` Zurück</a></div>
                    </div>
                    <div class="mobile-menu-pane menu-pane pane"></div>
                    <div class="parent-menu-pane menu-pane pane"></div>
                    <div class="current-menu-pane menu-pane pane"></div>
                </div>
            </div>
        </div>`;

        this.overlayContainer.querySelectorAll('.back-link a').forEach(el => {
            el.addEventListener('click', (e) => {
                if(e.target.parentElement.getAttribute('data-back-link-uid') !== "0") {
                    this.setCurrentMenu(e.target.parentElement.getAttribute('data-back-link-uid'), {'reversed': true});
                }

                if(e.target.parentElement.classList.contains('back-link-mobile')) {
                    this.currentMenuLevel = "0";
                    this.parentMenuBackLink = "0";
                    this.updateOpenState();
                }
            });
        })

        if (uid > 0) {
            this.setCurrentMenu(uid);
        }

        this.mobiletMenuPane = this.buildMobileMenu();
        window.app.siteHeader.menuShown = true;
        // console.log('open menu for uid:' + uid);
    }

    get mobiletMenuPane() {
        if (this.overlayContainer === null) { return null; }

        return this.overlayContainer.querySelector('.mobile-menu-pane');
    }

    set mobiletMenuPane(html) {
        if (this.mobiletMenuPane !== null) {
            this.mobiletMenuPane.classList.add('has-content');
            this.mobiletMenuPane.innerHTML = html;
            this.registerMenuItemClickHandlers(this.mobiletMenuPane);
        }
    }

    buildMobileMenu() {
        const breadcrumbsHome = document.querySelector('meta[name="breadcrumbs-home"]')?.content ?? 'Home';

        let menu = `<a class="title" href="/" target="">${breadcrumbsHome}</a>`;
        menu += Array.from(this.root.querySelectorAll('.menu-item[data-menu-level="0"]')).map(el => {
            return `<div ` + Array.from(el.attributes).map(el => el.name + '="' + el.value + '"').join(' ') + `>`
                + el.querySelector(':scope > a').outerHTML + `</div>`;
        }).join("\n");

        menu += `<hr/>`;

        let menuLinksElement = document.getElementById('mb-menu-links');
        if (menuLinksElement) {
            menu += menuLinksElement.innerHTML;
        }

        return menu;
    }

    closeMenu() {
        // console.log('handle window close in menu');
        window.app.siteHeader.menuShown = false;

        if (this.overlayContainer !== null) { this.overlayContainer = null; }

        this.nodes.forEach((node) => { node.classList.remove('open'); });
        this.root.classList.remove('opened');
    }

    animatePane(pane, direction) {
        let animateLeftToRight = [
            { transform: 'translate(-365px, 0)', },
            { transform: 'translate(0, 0)', },
        ];

        let animateRightToLeft = [
            { transform: 'translate(365px, 0)', },
            { transform: 'translate(0, 0)', },
        ];

        pane.animate(
            direction === 'left-to-right' ? animateLeftToRight :  animateRightToLeft,
            {
                duration: 500,
                iterations: 1,
                fill: 'forwards'
            }
        );
    }

    set currentMenuLevel(level) {
        let oldLevel = this.currentMenuLevel;

        let animations = [];
        // Mobile
        if (level <= 1 && level < oldLevel) {
            animations.push({element: this.mobiletMenuPane, direction: 'left-to-right'});
        }

        // current
        if (level > 0) {
            animations.push({element: this.currentMenuPane, direction: level < oldLevel ? 'left-to-right' : 'right-to-left'});
        }

        let isMobile = window.app.siteHeader.isMobileMode;// window.app.root.querySelector('.mb-tooltab').checkVisibility();

        // parent desktop
        if (isMobile) {
            if (level > 1 && level !== oldLevel) {
                animations.push({element: this.parentMenuPane, direction: level < oldLevel ? 'left-to-right' : 'right-to-left'});
            }
        } else {
            if (level > 1 && level !== oldLevel && !(level == 2 && oldLevel == 1)) {
                animations.push({element: this.parentMenuPane, direction: level < oldLevel ? 'left-to-right' : 'right-to-left'});
            }
        }

        this.overlayContainer.querySelector('.sliding-pane-menu-overlay')
            .setAttribute('data-current-menu-level', level);

        // console.log(animations);
        animations.forEach(a => {
            this.animatePane(a.element, a.direction);
        });
    }

    get currentMenuLevel() {
        return this.overlayContainer.querySelector('.sliding-pane-menu-overlay')
            .getAttribute('data-current-menu-level');
    }

    get currentMenuPane() {
        if (this.overlayContainer === null) { return null; }

        return this.overlayContainer.querySelector('.current-menu-pane');
    }

    registerMenuItemClickHandlers(pane) {
        pane.querySelectorAll('.menu-item.has-children a')
            .forEach(el => {
               el.addEventListener('click', (e) => {
                   this.setCurrentMenu(e.target.parentElement.getAttribute('data-menu-uid'));
                   e.preventDefault();
               });
            });
    }

    set currentMenuPane(html) {
        if (this.currentMenuPane !== null) {
            if (html === '') {
                this.currentMenuPane.classList.remove('has-content');
            } else {
                this.currentMenuPane.classList.add('has-content');
                this.currentMenuPane.innerHTML = html;
                this.registerMenuItemClickHandlers(this.currentMenuPane);
            }
        }
    }

    get parentMenuPane() {
        if (this.overlayContainer === null) { return null; }

        return this.overlayContainer.querySelector('.parent-menu-pane');
    }

    set parentMenuPane(html) {
        if (this.parentMenuPane !== null) {
            if (html === '') {
                this.parentMenuPane.classList.remove('has-content');
                this.parentMenuPane.innerHTML = html;
            } else {
                this.parentMenuPane.classList.add('has-content');
                this.parentMenuPane.innerHTML = html;
                this.registerMenuItemClickHandlers(this.parentMenuPane);
            }
        }
    }

    get textPane() {
        if (this.overlayContainer === null) { return null; }

        return this.overlayContainer.querySelector('.text-pane');
    }

    set textPane(text) {
        if (this.textPane !== null) {
            if (text === '') {
                this.textPane.classList.remove('has-content');
                this.textPane.innerHTML = "";
            } else {
                this.textPane.classList.add('has-content');
                this.textPane.innerHTML = "<p>" + text + "</p>";
            }
        }
    }

    set parentMenuBackLink(uid) {
        this.overlayContainer.querySelector('.back-link-parent')
            .setAttribute('data-back-link-uid', uid);
    }

    updateOpenState() {
        this.overlayContainer.querySelectorAll('.panes .menu-item')
            .forEach(el => {
               el.classList.remove('open');
               if (this.currentMenuLevel !== "0" &&
                   el.getAttribute('data-menu-uid') === this.currentMenu.uid) {
                   el.classList.add('open');
               }
            });
    }

    getTextSlideUp(menu) {
        if (menu.text !== '') {
            return menu.text;
        }

        if (menu.hasParentMenu) {
            let pMenu = this.getMenuByUid(menu.parentMenuUid);
            return this.getTextSlideUp(pMenu);
        } else {
            return '';
        }
    }

    setCurrentMenu(uid, options) {
        // { reversed:false }
        // console.log('switch menu for uid:' + uid);
        this.currentMenu = this.getMenuByUid(uid);
        this.currentMenuPane = this.currentMenu.renderMenu(uid);
        this.currentMenuLevel = this.currentMenu.menuLevel;
        this.textPane = this.getTextSlideUp( this.currentMenu);

        if (this.currentMenu.hasParentMenu) {
            this.parentMenu = this.getMenuByUid(this.currentMenu.parentMenuUid);
            this.parentMenuPane = this.parentMenu.renderMenu(this.currentMenu.parentMenuUid);
            this.parentMenuBackLink = this.parentMenu.uid;

        } else {
            // console.log('no parent');
            this.parentMenu = null;
            this.parentMenuPane = '';
            this.parentMenuBackLink = "0";
        }

        this.updateOpenState();
    }

    getMenuByUid(uid) {
        if (this.root.querySelector('.submenu[data-menu-uid="' + uid + '"]') === null) {
            return new SubMenu(document.querySelector('.submenu[data-menu-uid="' + uid + '"]'));
        } else {
            return new SubMenu(this.root.querySelector('.submenu[data-menu-uid="' + uid + '"]'));
        }
    }

    toggleMobileMenu() {
        if (this.overlayContainer !== null) {
            window.app.siteHeader.closeOverlay();
        } else {
            this.openMenu(0);
            this.animatePane(this.mobiletMenuPane, 'left-to-right');
        }
    }

    constructor(root) {
        this.root = root;

        this.overlayContainer = null;
        this.currentMenu = null;
        this.parentMenu = null;

        this.nodes = this.root.querySelectorAll('.menu-item[data-menu-level="0"][data-has-children="1"]');
        this.nodes.forEach((node) => {
            let menuItem = new MenuItem(node);

            if (menuItem.hasChildren) {
                node.addEventListener('click', (event) => {
                    event.preventDefault();

                    if (this.overlayContainer === null) {
                        this.openMenu(menuItem.menuUid);

                        menuItem.element.classList.add('open');
                        this.root.classList.add('opened');
                    } else if (this.currentMenu.uid === menuItem.menuUid) {
                        window.app.siteHeader.closeOverlay();
                    } else {
                        this.setCurrentMenu(menuItem.menuUid);

                        this.nodes.forEach((node) => { node.classList.remove('open'); });
                        menuItem.element.classList.add('open');
                    }
                });
            }
        });

        window.addEventListener('resize', this.resize.bind(this));

        window.app.siteHeader.registerMobileMenuToggle(() => {
            this.toggleMobileMenu();
        });
    }

    resize() {
        if (this.overlayContainer !== null) {
            window.app.siteHeader.closeOverlay();
        }
    }
}

window.app.run(() => {
    document.querySelectorAll('.dt-menu.sliding-panes-menu').forEach((node) => {
        new SlidingPanesMenu(node);
    });
});
